// Single source of truth for the landing-page FAQ (Iter 56).
// Consumed by both:
//   1. LandingPublic.jsx (visible accordion)
//   2. SeoHead JSON-LD generator on the homepage (FAQPage schema)
// If you edit this file, both the on-page FAQ and the structured-data
// payload update in lockstep. Never hand-duplicate this content elsewhere.

export const FAQ = [
  {
    q: "What does Acquigine actually do?",
    a: "Acquigine is an acquisition intelligence platform. We find acquisition opportunities from public records and registries, score every deal across six dimensions, and give you a CRM, outreach, and document workflow to actually close. We sit between opportunity discovery and signed LOI.",
  },
  {
    q: "How does the platform find opportunities? Is this compliant?",
    a: "Opportunities come from public records and registries. Coverage varies by location and changes over time. Available locations are shown inside the product. No scraping. No terms-of-service violations. Full audit trail on every record. Our data practices, including named providers, are detailed in our Privacy Policy.",
    aLink: { text: "Privacy Policy", to: "/privacy" },
  },
  {
    q: "What does the scoring actually measure?",
    a: "Six dimensions per opportunity: Seller Motivation, Life Events, Receptivity, Deal Viability, Owner Accessibility, and Lead Freshness. You see the reasoning and the signals that fired on every record, not a black box. Newly loaded records are marked first pass and score conservatively until more evidence is added.",
  },
  {
    q: "Can I import my own deal list?",
    a: "Yes. Business includes bulk CSV import for your entire deal list, plus webhook ingestion so your data partners can push deals directly into your pipeline. On any tier you can add opportunities one at a time through the intake form.",
  },
  {
    q: "Whose brand appears on the documents and emails I send?",
    a: "Yours. Every document you generate carries your name, company, and contact details as the primary identity, and Pro and Business subscribers get their logo and brand colors on every document. Outreach emails go out entirely under your name, from your own connected email account. Acquigine appears only as a small 'Prepared using Acquigine' credit in the document footer, never in your outreach.",
  },
  {
    q: "Is there a free tier?",
    a: "Yes. Free includes 5 saved opportunities per month with scoring visible. Upgrade to Pro or Business when you are ready to send outreach and generate documents. No credit card required to start.",
  },
];
